import { Component, Input } from '@angular/core';
import { AvatarSize, AvatarState } from '@rivethealth/data/options';
import { Observable, ReplaySubject } from 'rxjs';
import { AvatarService } from '../../api/avatar.service';
import { ChangeService } from '../core/change.service';
import { AbbreviateLastNamePipe } from './abbreviate-last-name.pipe';

interface User {
  id: number;
  name: string;
}

const MAX_AVATARS = 3;

@Component({
  selector: 'avatar-stack',
  templateUrl: './avatar-stack.component.html',
  styleUrls: ['./avatar-stack.component.scss'],
  providers: [AbbreviateLastNamePipe],
})
export class AvatarStackComponent {
  @Input('users')
  set inputUsers(value: User[]) {
    if (value != null) {
      this.users.next(value);
    }
  }

  users = new ReplaySubject<User[]>(1);

  namesStr: string;

  avatarStates: Observable<AvatarState>[];

  constructor(
    private abbreviateLastNamePipe: AbbreviateLastNamePipe,
    private readonly avatarService: AvatarService,
    private readonly changeService: ChangeService,
  ) {
    this.changeService.listen(this.users, users => {
      this.namesStr = users
        .map(user => this.abbreviateLastNamePipe.transform(user.name))
        .join(', ');

      this.avatarStates = users
        .slice(0, MAX_AVATARS)
        .map(user =>
          this.avatarService.getAvatarState(
            user.id,
            AvatarSize.SMALL,
            null,
            user.name,
          ),
        );
    });
  }
}
